import { useAppDispatch, useAppSelector } from 'hooks';
import { selectPersistedLiveChatComponents } from 'reducers/workflows';
import { useEffect } from 'react';
import type { WidgetComponent } from 'api/types';
import { isEventMessageComponent } from 'api/types';
import { concludeLiveChat } from 'actions/live-chat';

export const useResolveLiveChatConversation = () => {
  const dispatch = useAppDispatch();
  const persistedLiveChatComponents = useAppSelector(
    selectPersistedLiveChatComponents,
  );

  useEffect(() => {
    const shouldResolveConversation = getShouldResolveConversation(
      persistedLiveChatComponents,
    );
    if (shouldResolveConversation) {
      dispatch(concludeLiveChat());
    }
  }, [dispatch, persistedLiveChatComponents]);
};

const getShouldResolveConversation = (
  liveChatComponents: WidgetComponent[] | null,
) => {
  const lastComponent =
    liveChatComponents && liveChatComponents[liveChatComponents.length - 1];
  if (lastComponent && isEventMessageComponent(lastComponent)) {
    return lastComponent.isConversationResolver;
  }
};
